export default __webpack_public_path__ + "static/media/Vue-icon.b9514adc.png";